module.exports = __webpack_public_path__ + "static/media/limchukang.342b83fb.png";